import React, { useState, useRef, useEffect } from 'react';
import { Icon } from 'components';
import { CenterModal } from 'react-spring-modal';
import 'react-spring-modal/dist/index.css';
import styled from 'styled-components';
import styles from 'styles/modal.module.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'lib/classNames';

const Modal = ({ visible, title, children, subTitle = '', onClose = () => null, style ={} , background= "bg-gray-200"}) => {
	// const modal = useRef(null);
	// const overlay = useRef(null);
	const [stateTitle, setTitle] = useState(title);
	const scrollbars_ref = useRef(null);

	const close = () => {
		// modal.current.appendChild(overlay.current);
		onClose();
	};

	// useEffect(() => {
	// 	const PARENT_IS_NOT_BODY = !!overlay.current ? overlay.current.parentElement !== document.body : false;
	// 	if (PARENT_IS_NOT_BODY) {
	// 		document.getElementById('monster-upsell-cart').appendChild(overlay.current);
	// 		overlay.current.style.opacity = 1;
	// 	}
	// }, [overlay.current]);

	return (
		<CenterModal isOpen={visible} onRequestClose={() => onClose()} className={`BottomModal__backdrop ${styles.modal}`}>
			<div  className={`${classNames('p-4 h-full w-full '+background)} ${styles.header}`}>
				<div className={styles.meta}>
					<h4>{stateTitle}</h4>
					{subTitle && <p>{subTitle}</p>}
				</div>
				<Icon icon="times" onClick={() => close()} />
			</div>
			<Scrollbars className={styles.content} style={style}>
				<div className={styles.wrapper}>{children(close, setTitle)}</div>
			</Scrollbars>
		</CenterModal>
	);
};

export default Modal;
